import './css/style.css';
import { showAllContent, isTouch } from './js/utils.js';
import { initAnimations } from './js/animations.js';
import { initTimeline } from './js/timeline.js';
import { initAccordion } from './js/accordion.js';
import { initSmoothScroll, initScrollToTop } from './js/scroll.js';
import { initContactForm } from './js/form.js';
import { startLinkedInStatsRefresh } from './js/linkedin-stats.js';

// Show content immediately
showAllContent();

// Load Motion async for animations
const motionReady = import('motion')
  .then(mod => ({ animate: mod.animate, scroll: mod.scroll, inView: mod.inView, stagger: mod.stagger }))
  .catch(() => null);

// Initialize Motion animations
motionReady.then(motion => {
  if (motion && !isTouch()) {
    initAnimations(motion);
  }
});

// Initialize other modules (always run)
initTimeline();
initAccordion();
initSmoothScroll();
initScrollToTop();
initContactForm();
startLinkedInStatsRefresh();

// Register Service Worker to clear old caches
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./sw.js').catch(() => {
    // Service Worker registration failed, continue without it
  });
}
